export default {"src":"/_next/static/media/purple-circle.acded791.svg","height":306,"width":322};